package ai.wagemix.web.components

import ai.wagemix.web.theme.WMBodySmallTextStyle
import ai.wagemix.web.theme.WMCaptionTextStyle
import ai.wagemix.web.theme.WMCardCornerVar
import ai.wagemix.web.theme.WMCardTitleTextStyle
import ai.wagemix.web.theme.WMContentWidthVar
import ai.wagemix.web.theme.WMFooterColumnsGapCompactVar
import ai.wagemix.web.theme.WMFooterColumnsGapVar
import ai.wagemix.web.theme.WMFooterPaddingBlockCompactVar
import ai.wagemix.web.theme.WMFooterPaddingBlockVar
import ai.wagemix.web.theme.WMHairlineVar
import ai.wagemix.web.theme.WMHeaderActionsGapVar
import ai.wagemix.web.theme.WMHeaderPaddingBlockVar
import ai.wagemix.web.theme.WMInlineGapVar
import ai.wagemix.web.theme.WMLabelStrongTextStyle
import ai.wagemix.web.theme.WMLabelTextStyle
import ai.wagemix.web.theme.WMOverlineTextStyle
import ai.wagemix.web.theme.WMPageGutterCompactVar
import ai.wagemix.web.theme.WMPageTitleTextStyle
import ai.wagemix.web.theme.WMSidebarItemGapVar
import ai.wagemix.web.theme.WMSidebarItemIconGapVar
import ai.wagemix.web.theme.WMSidebarItemPaddingBlockVar
import ai.wagemix.web.theme.WMSidebarItemPaddingInlineVar
import ai.wagemix.web.theme.WMSidebarPaddingVar
import ai.wagemix.web.theme.WMSidebarSectionGapVar
import ai.wagemix.web.theme.WMSidebarWidthVar
import ai.wagemix.web.theme.WMTightGapVar
import ai.wagemix.web.theme.WMTopBarHeightVar
import ai.wagemix.web.theme.WMTopBarPaddingBlockVar
import ai.wagemix.web.theme.WMWordmarkTextStyle
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import androidx.compose.runtime.key
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.fsryan.foundation.web.components.FSImage
import com.fsryan.foundation.web.components.FSImageSize
import com.fsryan.foundation.web.theme.FSBreakpoint
import com.fsryan.foundation.web.theme.FSMotionShortVar
import com.fsryan.foundation.web.theme.fs
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.RowScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRight
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateColumns
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.role
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import com.varabyte.kobweb.compose.css.TextDecorationLine
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Nav

/*
 * Shell components: the logo, the marketing header and footer, the app sidebar and top bar.
 * They take state and callbacks only; the site's @Layouts compose them (web-screen playbook
 * invariant 5).
 */

/** Penpot `Wagemix / Logo`: the 32px mark beside the wordmark; the mark alone when [markOnly]. */
@Composable
fun WMLogo(
    markLightSrc: String,
    markDarkSrc: String,
    modifier: Modifier = Modifier,
    markOnly: Boolean = false,
    wordmark: String = "Wagemix"
) {
    val dark = ColorMode.current.isDark
    Row(modifier = Modifier.gap(WMInlineGapVar.value()).then(modifier), verticalAlignment = Alignment.CenterVertically) {
        FSImage(
            src = if (dark) markDarkSrc else markLightSrc,
            description = wordmark,
            size = FSImageSize.Intrinsic(32, 32),
            loading = com.varabyte.kobweb.silk.components.graphics.ImageLoading.Eager
        )
        if (!markOnly) SpanText(wordmark, WMWordmarkTextStyle.toModifier())
    }
}

/** One navigation entry. */
data class WMNavItem(
    val label: String,
    val path: String,
    val glyph: WMIconGlyph? = null,
    val active: Boolean = false,
    /** A count badge (saved mixes, uploads). */
    val count: Int? = null,
    /** Runs when the item is clicked, before its link navigates (the sidebar's mixes report the open). */
    val onClick: (() -> Unit)? = null
)

val WMNavLinkStyle = CssStyle {
    base {
        val colors = colorMode.toPalette().fs
        Modifier
            .color(colors.onSurfaceVariant)
            .textDecorationLine(TextDecorationLine.None)
            .transition(Transition.of("color", FSMotionShortVar.value()))
    }
    hover { Modifier.color(colorMode.toPalette().fs.onSurface) }
}

val WMNavLinkActiveStyle = CssStyle.base { Modifier.color(colorMode.toPalette().fs.primary) }

/** A marketing-nav link: label text, primary when active. */
@Composable
fun WMNavLink(item: WMNavItem, modifier: Modifier = Modifier) {
    Link(
        path = item.path,
        modifier = WMNavLinkStyle.toModifier()
            .then(if (item.active) WMNavLinkActiveStyle.toModifier() else Modifier)
            .then(WMLabelTextStyle.toModifier())
            .then(modifier),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)
    ) {
        SpanText(item.label)
    }
}

val WMMarketingHeaderStyle = CssStyle {
    base {
        val colors = colorMode.toPalette().fs
        Modifier
            .fillMaxWidth()
            .position(Position.Sticky)
            .top(0.px)
            .zIndex(10)
            .backgroundColor(colors.background)
            .borderBottom(width = WMHairlineVar.value(), style = LineStyle.Solid, color = colors.outlineVariant)
    }
}

val WMMarketingHeaderInnerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(WMContentWidthVar.value())
            .styleModifier { property("margin-inline", "auto") }
            .padding(topBottom = WMHeaderPaddingBlockVar.value(), leftRight = WMPageGutterCompactVar.value())
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.SpaceBetween)
            .gap(WMHeaderActionsGapVar.value())
    }
    FSBreakpoint.Large { Modifier.padding(topBottom = WMHeaderPaddingBlockVar.value(), leftRight = 0.px) }
}

/**
 * Penpot `Wagemix / Marketing Header` (Large | Compact): logo, nav links (hidden below the
 * expanded size), an [actions] slot ([Log in] [Start free] and the theme toggle) and a menu
 * button on phones that calls [onMenuClick].
 */
@Composable
fun WMMarketingHeader(
    logo: @Composable () -> Unit,
    items: List<WMNavItem>,
    menuLabel: String,
    onMenuClick: () -> Unit,
    modifier: Modifier = Modifier,
    actions: @Composable RowScope.() -> Unit
) {
    Div(attrs = WMMarketingHeaderStyle.toModifier().then(modifier).toAttrs()) {
        Div(attrs = WMMarketingHeaderInnerStyle.toModifier().toAttrs()) {
            logo()
            Nav(attrs = Modifier.displayIfAtLeast(FSBreakpoint.Expanded).toAttrs()) {
                Row(modifier = Modifier.gap(32.px), verticalAlignment = Alignment.CenterVertically) {
                    items.forEach { WMNavLink(it) }
                }
            }
            Row(modifier = Modifier.gap(WMHeaderActionsGapVar.value()), verticalAlignment = Alignment.CenterVertically) {
                Row(modifier = Modifier.gap(WMHeaderActionsGapVar.value()).displayIfAtLeast(FSBreakpoint.Expanded), verticalAlignment = Alignment.CenterVertically) {
                    actions()
                }
                WMIconButton(WMIconGlyph.Menu, accessibilityString = menuLabel, modifier = Modifier.displayUntil(FSBreakpoint.Expanded), onClick = onMenuClick)
            }
        }
    }
}

/** A footer column: an overline heading over links. */
data class WMFooterColumn(val heading: String, val links: List<WMNavItem>)

val WMMarketingFooterStyle = CssStyle {
    base {
        val colors = colorMode.toPalette().fs
        Modifier
            .fillMaxWidth()
            .backgroundColor(colors.surfaceContainerLow)
            .borderTop(width = WMHairlineVar.value(), style = LineStyle.Solid, color = colors.outlineVariant)
            .padding(topBottom = WMFooterPaddingBlockCompactVar.value(), leftRight = WMPageGutterCompactVar.value())
    }
    FSBreakpoint.Expanded { Modifier.padding(topBottom = WMFooterPaddingBlockVar.value(), leftRight = WMPageGutterCompactVar.value()) }
}

val WMMarketingFooterGridStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .maxWidth(WMContentWidthVar.value())
            .styleModifier { property("margin-inline", "auto") }
            .display(DisplayStyle.Grid)
            .gridTemplateColumns { size(1.fr) }
            .gap(WMFooterColumnsGapCompactVar.value())
    }
    FSBreakpoint.Expanded {
        Modifier.gridTemplateColumns { size(2.fr); repeat(3) { size(1.fr) } }.gap(WMFooterColumnsGapVar.value())
    }
}

/**
 * Penpot `Wagemix / Marketing Footer`: the logo and tagline, link columns, and a bottom row
 * with the copyright and the data-source line.
 */
@Composable
fun WMMarketingFooter(
    logo: @Composable () -> Unit,
    tagline: String,
    columns: List<WMFooterColumn>,
    copyright: String,
    dataSource: String,
    modifier: Modifier = Modifier
) {
    val colors = ColorMode.current.toPalette().fs
    Div(attrs = WMMarketingFooterStyle.toModifier().then(modifier).toAttrs()) {
        Column(modifier = Modifier.fillMaxWidth().maxWidth(WMContentWidthVar.value()).styleModifier { property("margin-inline", "auto") }.gap(WMFooterColumnsGapCompactVar.value())) {
            Div(attrs = WMMarketingFooterGridStyle.toModifier().toAttrs()) {
                Column(modifier = Modifier.gap(WMInlineGapVar.value())) {
                    logo()
                    SpanText(tagline, WMBodySmallTextStyle.toModifier().color(colors.onSurfaceVariant).maxWidth(320.px))
                }
                columns.forEach { column ->
                    Column(modifier = Modifier.gap(WMInlineGapVar.value())) {
                        SpanText(column.heading, WMOverlineTextStyle.toModifier().color(colors.onSurfaceVariant))
                        column.links.forEach { WMNavLink(it) }
                    }
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth().gap(WMInlineGapVar.value())
                    .borderTop(width = WMHairlineVar.value(), style = LineStyle.Solid, color = colors.outlineVariant)
                    .padding(top = WMInlineGapVar.value())
                    .styleModifier { property("flex-wrap", "wrap"); property("justify-content", "space-between") }
            ) {
                SpanText(copyright, WMCaptionTextStyle.toModifier().color(colors.onSurfaceVariant))
                SpanText(dataSource, WMCaptionTextStyle.toModifier().color(colors.onSurfaceVariant))
            }
        }
    }
}

val WMSidebarItemStyle = CssStyle {
    base {
        val colors = colorMode.toPalette().fs
        Modifier
            .fillMaxWidth()
            .padding(topBottom = WMSidebarItemPaddingBlockVar.value(), leftRight = WMSidebarItemPaddingInlineVar.value())
            .gap(WMSidebarItemIconGapVar.value())
            .borderRadius(WMCardCornerVar.value())
            .color(colors.onSurfaceVariant)
            .textDecorationLine(TextDecorationLine.None)
            .transition(Transition.of("background-color", FSMotionShortVar.value()))
            .cursor(Cursor.Pointer)
    }
    hover { Modifier.backgroundColor(colorMode.toPalette().fs.surfaceContainer) }
}

/** A sidebar label takes the row and ends in an ellipsis when it does not fit (long mix titles). */
val WMSidebarItemLabelStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .minWidth(0.px)
        .overflow(Overflow.Hidden)
        .textOverflow(TextOverflow.Ellipsis)
        .whiteSpace(WhiteSpace.NoWrap)
}

val WMSidebarItemActiveStyle = CssStyle.base {
    val colors = colorMode.toPalette().fs
    Modifier.backgroundColor(colors.primaryContainer).color(colors.onPrimaryContainer)
}

/** Penpot `Wagemix / Sidebar Item`: glyph, label, optional count; the active item is tinted. */
@Composable
fun WMSidebarItem(item: WMNavItem, modifier: Modifier = Modifier) {
    val colors = ColorMode.current.toPalette().fs
    Link(
        path = item.path,
        modifier = WMSidebarItemStyle.toModifier()
            .then(if (item.active) WMSidebarItemActiveStyle.toModifier() else Modifier)
            .then(if (item.active) WMLabelStrongTextStyle.toModifier() else WMLabelTextStyle.toModifier())
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .styleModifier { if (item.active) property("aria-current", "page") }
            .then(item.onClick?.let { click -> Modifier.onClick { click() } } ?: Modifier)
            .then(modifier),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)
    ) {
        item.glyph?.let { WMIcon(it, accessibilityString = null) }
        SpanText(item.label, WMSidebarItemLabelStyle.toModifier())
        item.count?.let { SpanText(it.toString(), WMCaptionTextStyle.toModifier().color(colors.onSurfaceVariant)) }
    }
}

val WMAppSidebarStyle = CssStyle.base {
    val colors = colorMode.toPalette().fs
    Modifier
        .width(WMSidebarWidthVar.value())
        .minHeight(100.percent)
        .flexShrink(0)
        .backgroundColor(colors.surfaceContainerLowest)
        .borderRight(width = WMHairlineVar.value(), style = LineStyle.Solid, color = colors.outlineVariant)
        .padding(WMSidebarPaddingVar.value())
        .gap(WMSidebarSectionGapVar.value())
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
}

/** The overline heading of a sidebar section ("Your mixes"), inset like the items under it. */
val WMSidebarSectionHeadingStyle = CssStyle.base {
    Modifier
        .padding(leftRight = WMSidebarItemPaddingInlineVar.value())
        .color(colorMode.toPalette().fs.onSurfaceVariant)
}

/**
 * Penpot `Wagemix / App Sidebar`: the logo, a [primaryAction] slot ([New mix]), the nav
 * [items], an optional section of [sectionItems] under [sectionHeading] (the user's mixes,
 * hidden when empty), and a [footer] slot (plan card, account, theme toggle, log out). The
 * same composable fills the phone drawer.
 */
@Composable
fun WMAppSidebar(
    logo: @Composable () -> Unit,
    items: List<WMNavItem>,
    modifier: Modifier = Modifier,
    sectionHeading: String? = null,
    sectionItems: List<WMNavItem> = emptyList(),
    /** Shows [sectionHeading] even without [sectionItems] (a lapsed account: "Your mixes · renew to see them"). */
    showEmptySection: Boolean = false,
    primaryAction: (@Composable () -> Unit)? = null,
    footer: (@Composable ColumnScope.() -> Unit)? = null
) {
    Column(modifier = WMAppSidebarStyle.toModifier().then(modifier)) {
        logo()
        primaryAction?.invoke()
        Nav(attrs = Modifier.fillMaxWidth().toAttrs()) {
            Column(modifier = Modifier.fillMaxWidth().gap(WMSidebarItemGapVar.value())) {
                items.forEach { WMSidebarItem(it) }
            }
        }
        if (sectionItems.isNotEmpty() || showEmptySection) {
            Column(modifier = Modifier.fillMaxWidth().gap(WMSidebarItemGapVar.value())) {
                sectionHeading?.let { SpanText(it, WMOverlineTextStyle.toModifier().then(WMSidebarSectionHeadingStyle.toModifier())) }
                Column(modifier = Modifier.fillMaxWidth().gap(WMSidebarItemGapVar.value()).role("list")) {
                    sectionItems.forEach { item ->
                        key(item.path) {
                            WMSidebarItem(item, modifier = Modifier.role("listitem"))
                        }
                    }
                }
            }
        }
        Column(modifier = Modifier.fillMaxWidth().gap(WMInlineGapVar.value()).styleModifier { property("margin-top", "auto") }) {
            footer?.invoke(this)
        }
    }
}

val WMAppTopBarStyle = CssStyle.base {
    val colors = colorMode.toPalette().fs
    Modifier
        .fillMaxWidth()
        .minHeight(WMTopBarHeightVar.value())
        .padding(topBottom = WMTopBarPaddingBlockVar.value(), leftRight = WMSidebarPaddingVar.value())
        .gap(WMHeaderActionsGapVar.value())
        .backgroundColor(colors.background)
        .borderBottom(width = WMHairlineVar.value(), style = LineStyle.Solid, color = colors.outlineVariant)
}

/** The top bar's page title: one line, shrinking with an ellipsis when the actions need the room. */
val WMAppTopBarTitleStyle = CssStyle.base {
    Modifier
        .whiteSpace(WhiteSpace.NoWrap)
        .minWidth(0.px)
        .overflow(Overflow.Hidden)
        .textOverflow(TextOverflow.Ellipsis)
}

/**
 * Penpot `Wagemix / App Top Bar`: a menu button on phones, the page [title], a [status] slot
 * (the "Unsaved mix" pill) and an [actions] slot ([Share] [Save mix]).
 */
@Composable
fun WMAppTopBar(
    title: String,
    menuLabel: String,
    onMenuClick: () -> Unit,
    modifier: Modifier = Modifier,
    status: (@Composable RowScope.() -> Unit)? = null,
    actions: (@Composable RowScope.() -> Unit)? = null
) {
    Row(modifier = WMAppTopBarStyle.toModifier().then(modifier), verticalAlignment = Alignment.CenterVertically) {
        WMIconButton(WMIconGlyph.Menu, accessibilityString = menuLabel, modifier = Modifier.displayUntil(FSBreakpoint.Expanded), onClick = onMenuClick)
        // The title gives way (ellipsis) before the status pill or the actions do.
        SpanText(title, WMPageTitleTextStyle.toModifier().then(WMAppTopBarTitleStyle.toModifier()))
        status?.let { Row(modifier = Modifier.gap(WMInlineGapVar.value()).flexShrink(0), verticalAlignment = Alignment.CenterVertically) { it() } }
        Row(
            modifier = Modifier.flexGrow(1).flexShrink(0).gap(WMHeaderActionsGapVar.value()).justifyContent(JustifyContent.FlexEnd),
            verticalAlignment = Alignment.CenterVertically
        ) {
            actions?.invoke(this)
        }
    }
}

/**
 * The sidebar's plan card: plan name badge, a line of text, an optional meter and an action. [badgeKind] is Warning
 * for a subscription that ended (ENDED).
 */
@Composable
fun WMPlanSummaryCard(
    planLabel: String,
    text: String,
    modifier: Modifier = Modifier,
    badgeKind: WMBadgeKind = WMBadgeKind.Plan,
    meterFraction: Double? = null,
    meterLabel: String? = null,
    action: (@Composable () -> Unit)? = null
) {
    val colors = ColorMode.current.toPalette().fs
    Column(
        modifier = Modifier.fillMaxWidth()
            .padding(WMSidebarPaddingVar.value())
            .gap(WMInlineGapVar.value())
            .borderRadius(WMCardCornerVar.value())
            .backgroundColor(colors.surfaceContainer)
            .then(modifier)
    ) {
        Row(modifier = Modifier.gap(WMTightGapVar.value()), verticalAlignment = Alignment.CenterVertically) {
            WMBadge(planLabel, kind = badgeKind)
            SpanText("plan", WMCaptionTextStyle.toModifier().color(colors.onSurfaceVariant))
        }
        SpanText(text, WMBodySmallTextStyle.toModifier().color(colors.onSurfaceVariant))
        if (meterFraction != null && meterLabel != null) {
            WMMeter(meterFraction, accessibilityString = meterLabel, warning = meterFraction >= 1.0)
        }
        action?.invoke()
    }
}

/** A section heading inside app pages ("Occupations", "Your uploads") with an optional trailing slot. */
@Composable
fun WMSectionHeading(title: String, modifier: Modifier = Modifier, trailing: (@Composable RowScope.() -> Unit)? = null) {
    Row(modifier = Modifier.fillMaxWidth().gap(WMInlineGapVar.value()).then(modifier), verticalAlignment = Alignment.CenterVertically) {
        SpanText(title, WMCardTitleTextStyle.toModifier().fillMaxWidth())
        trailing?.invoke(this)
    }
}
